export default [
    // *========come===========Bank List============================---*
    {
        path: '/expenses/:id',
            name: 'expenses',
            component: () => import('@/views/accounting/Expenses/expenses.vue'),
            meta: {
                pageTitle: 'Expenses',
                breadcrumb: [
                    {
                        text: 'Expenses',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]